import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "progressBar", "progressText", "nextButton", "prevButton", "submitButton", "proofMin", "proofMax", "proofMinValue", "proofMaxValue"]
  static values = { currentStep: { type: Number, default: 1 }, totalSteps: { type: Number, default: 5 } }

  connect() {
    this.showStep(this.currentStepValue)
    this.updateProgress()
  }

  next(event) {
    event.preventDefault()
    if (this.currentStepValue < this.totalStepsValue) {
      this.currentStepValue++
      this.showStep(this.currentStepValue)
      this.updateProgress()
    }
  }

  previous(event) {
    event.preventDefault()
    if (this.currentStepValue > 1) {
      this.currentStepValue--
      this.showStep(this.currentStepValue)
      this.updateProgress()
    }
  }

  showStep(stepNumber) {
    this.stepTargets.forEach((step, index) => {
      if (index + 1 === stepNumber) {
        step.classList.remove("hidden")
      } else {
        step.classList.add("hidden")
      }
    })

    // Update button visibility
    if (this.hasPrevButtonTarget) {
      if (stepNumber === 1) {
        this.prevButtonTarget.classList.add("invisible")
      } else {
        this.prevButtonTarget.classList.remove("invisible")
      }
    }

    if (this.hasNextButtonTarget && this.hasSubmitButtonTarget) {
      if (stepNumber === this.totalStepsValue) {
        this.nextButtonTarget.classList.add("hidden")
        this.submitButtonTarget.classList.remove("hidden")
      } else {
        this.nextButtonTarget.classList.remove("hidden")
        this.submitButtonTarget.classList.add("hidden")
      }
    }

    // Scroll to top of form
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  updateProgress() {
    const progress = (this.currentStepValue / this.totalStepsValue) * 100

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${progress}%`
    }

    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = `Step ${this.currentStepValue} of ${this.totalStepsValue}`
    }
  }

  // Proof range slider handlers
  updateProofMin(event) {
    const value = event.target.value

    if (this.hasProofMinValueTarget) {
      this.proofMinValueTarget.textContent = value
    }

    if (this.hasProofMinTarget) {
      this.proofMinTarget.value = value
    }

    // Ensure min doesn't exceed max
    if (this.hasProofMaxTarget && parseInt(value) > parseInt(this.proofMaxTarget.value)) {
      this.proofMaxTarget.value = value
      if (this.hasProofMaxValueTarget) {
        this.proofMaxValueTarget.textContent = value
      }
    }
  }

  updateProofMax(event) {
    const value = event.target.value

    if (this.hasProofMaxValueTarget) {
      this.proofMaxValueTarget.textContent = value
    }

    if (this.hasProofMaxTarget) {
      this.proofMaxTarget.value = value
    }

    // Ensure max doesn't go below min
    if (this.hasProofMinTarget && parseInt(value) < parseInt(this.proofMinTarget.value)) {
      this.proofMinTarget.value = value
      if (this.hasProofMinValueTarget) {
        this.proofMinValueTarget.textContent = value
      }
    }
  }
}
